import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Avatar,
  Box,
  Center,
  Flex,
  HStack,
  Image,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import DashboardHeader from "../../../components/common/DashboardHeader";
import TraineeSidenav from "../../../components/trainee/courses/Sidenav";
import bolaji from "../../../img/bolaji.jpg";
import fb from "../../../img/fb.png";
import linkedin from "../../../img/lin.png";
import notepad from "../../../img/notepad.svg";
import Engineer from "../../../img/selEngineers.svg";
import twitter from "../../../img/twit.png";

import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { BsStar, BsStarFill } from "react-icons/bs";
import { useParams } from "react-router-dom";
import Loading from "../../../components/common/Loading";
import { IAllCourse } from "../../../models/allcourse.model";
import { ICourseTrainers } from "../../../models/course-enrolment.model";
import coursesService from "../../../services/courses.service";
import registrationService from "../../../services/registration.service";
import trainercoursesService from "../../../services/trainer/trainercourses.service";
import { getFullDate } from "../../../utils/classOfDegree";
import TraineeMobileNav from "../../../components/common/TraineeMobileNav";

const CourseInformation = () => {
  const { course_id } = useParams();
  const [course, setCourse] = useState<IAllCourse>();
  const [loading, setLoading] = useState(true);
  const [courseReview, setCourseReview] = useState<any[]>();
  const showSideNav = useBreakpointValue({ base: false, md: true, lg: true });

  useEffect(() => {
    registrationService
      .getEachCourse(course_id)
      .then((response) => {
        setCourse(response);
      })
      .catch((err) => err);

    trainercoursesService
      .getCourseReviews(course_id)
      .then((response) => {
        setCourseReview(response.data);
        console.log(response.data, "course reviewww")
        setLoading(false);
      })
      .catch((err) => err);
  }, []);
  return (
    <>
      <DashboardHeader />
      {loading ? (
        <Loading />
      ) : (
        <Box bg="#F9F8F8">
          {!showSideNav && <TraineeMobileNav courseId={course_id || ""} />}
          <Flex
            width="90%"
            mx="auto"
            pt={["50px","80px"]}
            minHeight="100vh"
            height="max-content"
            pb={"30px"}
          >
            {showSideNav && <TraineeSidenav/>}

            <Box width={["90%", "80%"]} mx={["auto", "auto", "0", "0"]}>
              <Flex bg="#2557D6" height="280px" width="100%">
                <Box width="50%">
                  <Box pt="40px" px="5%">
                    <Text
                      fontSize="25px"
                      color="white"
                      fontWeight="800"
                      textAlign="left"
                    >
                      {course?.name}
                    </Text>

                    <Text
                      mt="15px"
                      fontSize="12px"
                      textAlign="left"
                      fontWeight="500"
                      color="white"
                    >
                      {course?.description
                        ? course?.description.substring(0, 300)
                        : ""}
                    </Text>
                  </Box>
                </Box>
                <Box width="50%">
                  {course?.cover_image ? (
                    <Image
                      objectFit="cover"
                      height="100%"
                      width="100%"
                      src={course?.cover_image}
                    />
                  ) : (
                    <Image
                      objectFit="cover"
                      height="100%"
                      width="100%"
                      src={Engineer}
                    />
                  )}
                </Box>
              </Flex>
              <Tabs colorScheme="red" bg="white">
                <TabList>
                  <Tab fontSize="13px" pt="17px" pb="17px" color="#616161">
                    Course Overiew
                  </Tab>
                  <Tab fontSize="13px" pt="17px" pb="17px" color="#616161">
                    Course Content
                  </Tab>
                  <Tab fontSize="13px" pt="17px" pb="17px" color="#616161">
                    Trainer
                  </Tab>
                  {/* <Tab fontSize="13px" pt="17px" pb="17px" color="#616161">
                    Review
                  </Tab> */}
                </TabList>

                {/* panel 1 */}

                <TabPanels bg="white">
                  <TabPanel>
                    <Box py="30px" width="95%" mx="auto" minHeight={"20rem"}>
                      <Text
                        color="#353535"
                        fontSize="20px"
                        pb="20px"
                        fontWeight="600"
                      >
                        About Course
                      </Text>
                      <Text pb="40px" color="#616161" fontSize="14px">
                        {course?.description}
                      </Text>
                      <Text
                        pb="14px"
                        color="#353535"
                        fontSize="20px"
                        fontWeight="600"
                      >
                        General Objective
                      </Text>
                      <Text pb="100px" color="#616161" fontSize="14px">
                        {course?.general_objective}
                      </Text>
                    </Box>
                  </TabPanel>
                  <TabPanel>
                    <Box py="30px" width="95%" mx="auto" minHeight={"20rem"}>
                      <Box width="100%" mx="auto">
                        <Text
                          color="#353535"
                          fontSize="20px"
                          pb="20px"
                          fontWeight="600"
                        >
                          Course Content
                        </Text>
                        {course &&
                          course.topics.length > 0 &&
                          course.topics.map((each, index) => {
                            return (
                              <Box
                                bg="#FDFDFD"
                                pb="30px"
                                mb="25px"
                                pt="30px"
                                key={index}
                              >
                                <Text
                                  ml="2.5%"
                                  color="#616161"
                                  fontSize="16px"
                                  fontWeight="500"
                                  pb="20px"
                                >
                                  Lecture {index + 1}: {each.title}
                                </Text>
                                {each.lessons.map(
                                  (
                                    lesson: {
                                      title: string;
                                      description: string;
                                    },
                                    index: number
                                  ) => {
                                    return (
                                      <Accordion
                                        allowToggle
                                        width="95%"
                                        mx="auto"
                                        key={index}
                                      >
                                        <AccordionItem bg="white" pb="10px">
                                          <h2>
                                            <AccordionButton>
                                              <Flex
                                                justifyContent="space-between"
                                                w="100%"
                                              >
                                                <HStack>
                                                  <Image src={notepad} />
                                                  <Box
                                                    flex="1"
                                                    textAlign="left"
                                                  >
                                                    {index + 1}: {lesson.title}
                                                  </Box>
                                                </HStack>
                                                <AccordionIcon />
                                              </Flex>
                                            </AccordionButton>
                                          </h2>
                                          <AccordionPanel pb={4}>
                                            {lesson.description}
                                          </AccordionPanel>
                                        </AccordionItem>
                                      </Accordion>
                                    );
                                  }
                                )}
                              </Box>
                            );
                          })}
                        {course?.topics.length == 0 && (
                          <Text
                            color="#353535"
                            fontSize="16px"
                            width={"100%"}
                            textAlign={"center"}
                            fontWeight="600"
                          >
                            No content uploaded for this course
                          </Text>
                        )}
                      </Box>
                    </Box>
                  </TabPanel>
                  <TabPanel>
                    <Box
                      py="30px"
                      width="95%"
                      mx="auto"
                      pr="60px"
                      minHeight={"20rem"}
                    >
                      <Text
                        color="#1E1E1E"
                        fontSize="20px"
                        pb="30px"
                        fontWeight="600"
                      >
                        About Trainer(s)
                      </Text>
                      {course &&
                        course?.trainers?.length > 0 &&
                        course.trainers?.map((each, index) => (
                          <Flex key={index}>
                            <Box mr="25px">
                              <Center
                                mx="auto"
                                mb="20px"
                                width="88px"
                                height="88px"
                                borderRadius="44px"
                              >
                                <Avatar size="md" name={each.name} />
                              </Center>
                              {/* <HStack spacing="7px" mx="auto">
                                <Image src={linkedin} />
                                <Image src={twitter} />
                                <Image src={fb} />
                              </HStack> */}
                            </Box>
                            <Box>
                              <Text
                                fontWeight="600"
                                color="#616161"
                                fontSize="14px"
                              >
                                {each.name}
                              </Text>
                              <Text
                                fontWeight="500"
                                color="#616161"
                                pb="15px"
                                fontSize="12px"
                              >
                                {each.category}
                              </Text>
                              <Box pb="30px">
                                <Text
                                  fontSize="12px"
                                  fontWeight="600"
                                  color="#616161"
                                >
                                  <a
                                    target="__blank"
                                    href={`mailto:${each.email}`}
                                  >
                                    {" "}
                                    Email-address: {each.email}
                                  </a>
                                </Text>
                                <Text
                                  fontSize="15px"
                                  fontWeight="600"
                                  color="#616161"
                                >
                                  Phone no: 0{each.phone}
                                </Text>
                                <Text
                                  fontSize="15px"
                                  fontWeight="600"
                                  color="#616161"
                                >
                                  Joined : {getFullDate(each.created_at)}
                                </Text>
                              </Box>
                            </Box>
                          </Flex>
                        ))}
                      {course?.trainers && course?.trainers.length === 0 && (
                        <Text
                          color="#353535"
                          fontSize="16px"
                          width={"100%"}
                          textAlign={"center"}
                          fontWeight="600"
                        >
                          No trainer assigned to this course
                        </Text>
                      )}
                    </Box>
                  </TabPanel>
                  {/* <TabPanel>
                    <Box
                      py="30px"
                      width="95%"
                      mx="auto"
                      pr="60px"
                      minHeight={"20rem"}
                    >
                      <Text
                        color="#1E1E1E"
                        fontSize="20px"
                        pb="30px"
                        fontWeight="600"
                      >
                        Course Review
                      </Text>

                      {courseReview &&
                        courseReview.length > 0 &&
                        courseReview.map((review, index) => {
                          return (
                            <Flex
                              pb="20px"
                              mb="20px"
                              borderBottom="1px solid "
                              borderColor="lightgrey"
                              key={index}
                            >
                              <Box mr="25px">
                                <Center
                                  mx="auto"
                                  mb="20px"
                                  bg="#C4C4C4"
                                  width="88px"
                                  height="88px"
                                  borderRadius="44px"
                                >
                                  <Image
                                    width="88px"
                                    height="88x"
                                    borderRadius="44px"
                                    src={bolaji}
                                  />
                                </Center>
                              </Box>
                              <Box mr="45px">
                                <Text
                                  fontWeight="400"
                                  color="#616161"
                                  fontSize="14px"
                                >
                                  2 days ago
                                </Text>
                                <Text
                                  fontWeight="600"
                                  color="#616161"
                                  fontSize="16px"
                                >
                                  Muili Bolaji
                                </Text>
                              </Box>
                              <Box width="75%">
                                <HStack mb="14px">
                                  <BsStarFill color="#E9A426" />
                                  <BsStarFill color="#E9A426" />
                                  <BsStarFill color="#E9A426" />
                                  <BsStarFill color="#E9A426" />
                                  <BsStar />
                                </HStack>
                                <Text
                                  fontSize="15px"
                                  fontWeight="400"
                                  color="#959595"
                                >
                                  A wonderful course on how to start. The course
                                  beautifully conveys all essentials of a
                                  construction engineering. Very glad to have
                                  taken this course.
                                </Text>
                              </Box>
                            </Flex>
                          );
                        })}
                      {courseReview?.length === 0 && (
                        <Text
                          color="#353535"
                          fontSize="16px"
                          width={"100%"}
                          textAlign={"center"}
                          fontWeight="600"
                        >
                          No reviews for this course
                        </Text>
                      )}
                    </Box>
                  </TabPanel> */}
                </TabPanels>
              </Tabs>
            </Box>
          </Flex>
        </Box>
      )}
    </>
  );
};

export default CourseInformation;
